<template>
    <div class="markets-aside" :class="{ 'markets-aside-opened': isMenuOpened }">
        <p class="markets-mobile-main-item" :class="{ 'markets-mobile-main-item-active' : isMenuOpened }" @click="toggleMenu()">{{navItems[0][1]}}</p>
        <ul class="markets-aside-ul">
          <li class="markets-aside-li" :class="{ 'markets-aside-li-active': isMenuOpened }" v-for="(item, index) in navItems" :key="'asideItem' + index">
              <a class="markets-aside-item" active-class="markets-aside-item-active" @click="itemSelected(item[0])">{{item[1]}}</a>
          </li>
        </ul>
    </div>
</template>

<script>
export default {
  // The components gets an array with nested string arrays as navItems
  // The first string is the name and the second is the id of the target item
  props: ["navItems"],
  data() {
    return {
      isMenuOpened: false
    };
  },
  methods: {
    toggleMenu() {
      this.isMenuOpened = this.isMenuOpened === false ? true : false;
    },
    itemSelected(item) {
      const selected = document.getElementById(item);
      if (selected) {
        window.scrollTo({
          top: selected.offsetTop - 100,
          behavior: "smooth"
        });
      }
      this.isMenuOpened = false;
    }
  }
};
</script>

<style scoped>
.markets-aside {
  align-self: flex-start;
  width: 20%;
}
.markets-aside {
  width: 20%;
  padding-top: 15px;
  padding-bottom: 30px;
}
.markets-aside-ul {
  padding: 10px 0 20px 0;
  border-right: 1px solid #c5d7e4;
}
.markets-aside-li {
  display: block;
  text-align: right;
}
.markets-aside-title {
  color: #00305b;
  display: block;
  font-size: 16px;
  padding: 15px 42px 15px 0;
  text-align: right;
}
.markets-aside-item {
  border-right: 6px solid transparent;
  display: block;
  font-size: 16px;
  text-transform: uppercase;
  height: 100%;
  padding: 11px 36px 11px 0;
}
.markets-aside-item:hover {
  border-right: 6px solid #00305b;
  color: #00305b;
}
.markets-aside-item-active {
  border-right: 6px solid #00305b;
  color: #00305b;
  font-weight: 700;
}
.markets-mobile-main-item {
  display: none;
}
@media screen and (max-width: 1280px) {
  .markets-aside {
    width: 30%;
  }
}
@media screen and (max-width: 1000px) {
  .markets-aside {
    background-color: rgba(0, 71, 133, 0.98);
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    border: 2px solid #fff;
    border-bottom: none;
    bottom: 0;
    left: 48px;
    max-height: calc(100vh - 90px);
    min-height: 50px;
    padding: 0;
    position: fixed;
    -webkit-transition: all 0.4s ease;
    -moz-transition: all 0.4s ease;
    -ms-transition: all 0.4s ease;
    -o-transition: all 0.4s ease;
    transition: all 0.4s ease;
    width: calc(100% - 96px);
    z-index: 9;
  }
  .markets-aside::after {
    color: #fff;
    content: "M";
    font-size: 18px;
    font-family: "alcomet";
    height: 20px;
    position: absolute;
    right: 20px;
    top: 15px;
    -webkit-transition: all 0.4s ease;
    -moz-transition: all 0.4s ease;
    -ms-transition: all 0.4s ease;
    -o-transition: all 0.4s ease;
    transition: all 0.4s ease;
    width: 20px;
  }
  .markets-aside-opened {
    z-index: 9;
  }
  .markets-aside-opened::after {
    transform: rotate(-180deg);
  }
  .markets-mobile-main-item {
    align-items: center;
    color: #fff;
    font-size: 18px;
    display: flex;
    height: 50px;
    padding: 0 20px;
    position: relative;
    width: 100%;
    z-index: 1;
  }
  .markets-mobile-main-item-active {
    display: none;
  }
  .markets-aside-ul {
    border: none;
    max-height: calc(100vh - 140px);
    overflow: auto;
    padding: 0;
  }
  .markets-aside-li {
    height: 0px;
    opacity: 0;
    overflow: hidden;
    -webkit-transition: all 0.4s ease;
    -moz-transition: all 0.4s ease;
    -ms-transition: all 0.4s ease;
    -o-transition: all 0.4s ease;
    transition: all 0.4s ease;
    text-align: left;
  }
  .markets-aside-li-active {
    height: 50px;
    opacity: 1;
  }
  .markets-aside-item {
    align-items: center;
    border: none;
    color: #fff;
    display: flex;
    font-size: 18px;
    padding: 0 20px;
    position: relative;
    text-transform: initial;
    z-index: 1;
  }
  .markets-aside-item:hover {
    border: none;
    color: #fff;
  }
}
@media screen and (max-width: 600px) {
  .markets-mobile-main-item,
  .markets-aside-item {
    font-size: 16px;
  }
  .markets-aside-li:first-of-type .markets-aside-item {
    padding-right: 50px;
  }
}
@media screen and (max-width: 440px) {
  .markets-aside {
    left: 30px;
    width: calc(100% - 60px);
  }
  .markets-mobile-main-item,
  .markets-aside-item {
    font-size: 13px;
  }
}
@media screen and (max-width: 380px) {
  .markets-mobile-main-item,
  .markets-aside-item {
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/markets/MarketsNav.vue